/**
 * Determine if the current window scope is in an iframe.
 *
 * @returns `true`, if the current window scope is in an iframe, otherwise
 * `false`.
 */
export const isInIframe = (): boolean =>
    typeof window !== "undefined" &&
    !!window.self &&
    !!window.top &&
    window.self !== window.top;
